import * as Yup from 'yup';
import { ITranslations } from 'components/OrderReturns/ReturnForm';
import { getTelephoneRegex } from '../../helpers/regex/Regex';

export const identificationRules = (labels: ITranslations) => {
    return Yup.object().shape({
        orderNumber: Yup.string().required(labels.errorRequired),
        email: Yup.string().required(labels.errorRequired).email(labels.errorEmail),
        phone: Yup.string().required(labels.errorRequired).matches(getTelephoneRegex(), labels.errorPhone),
    });
};

export const detailsRules = (labels: ITranslations) => {
    return Yup.object().shape({
        firstName: Yup.string().required(labels.errorRequired).min(2, labels.errorName),
        lastName: Yup.string().required(labels.errorRequired).min(2, labels.errorName),
        reason: Yup.string().required(labels.errorRequired),
        confirmed: Yup.boolean().oneOf([true], labels.errorRequired),
    });
};
